import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { IAppState } from '@mafc/common';

import FEATURES_CONFIG from 'config/features';
import { IFinalPrice, IPrice, getFormattedPriceInUSD } from 'utils/price.util';

import * as S from './PrinceInUSD.style';

const PriceInUSD: React.FC<{
  variant: 'cartOrderSummary' | 'checkoutOrderSummary' | 'viewDetailDrawer'; // variant tells about the component's placement
  price: IPrice | IFinalPrice;
}> = ({ price, variant }) => {
  const { t } = useTranslation();
  const currencyRate = useSelector(
    (state: IAppState) => state.appConfig && state.appConfig.currencyRate
  );

  const { showPriceInUSD } = FEATURES_CONFIG.settings;

  return showPriceInUSD ? (
    <S.PriceInUSD variant={variant}>
      {t('orderSummary.approx')} {getFormattedPriceInUSD(price, currencyRate)}
    </S.PriceInUSD>
  ) : null;
};

export default PriceInUSD;
